import { animate, style, transition, trigger } from "@angular/animations";

export const Fade = trigger('Fade', [
    transition(':enter', [
        style({
            transform: 'scale(0.99)',
            opacity: 0
        }),
        animate('0.16s',
            style({
                transform: 'scale(1)',
                opacity: 1
            })
        )
    ]),
    transition(':leave', [
        style({
            transform: 'scale(1)',
            opacity: 1
        }),
        animate('0.16s',
            style({
                transform: 'scale(0.99)',
                opacity: 0
            })
        )
    ])
]);